import type { ComponentProps } from "react"

export default function Plot(props: ComponentProps<"svg"> & { fill?: string }) {
  const { fill = "hsl(var(--foreground))", ...svgProps } = props

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.673 15C14.041 15 14.8 12.997 14.8 10.562C14.8 5.67598 11.825 1.19998 7.696 1.19998C6.56882 1.10969 5.45384 1.48496 4.61064 2.23842C3.76744 2.99188 3.26959 4.05778 3.233 5.18798C3.069 8.52398 1 8.82298 1 10.453C1.00436 11.2415 1.32987 11.9942 1.90143 12.5375C2.47299 13.0808 3.24126 13.3676 4.029 13.332C4.509 13.332 4.992 13.224 5.583 13.224C7.887 13.224 9.05 15 11.673 15ZM11.673 14C10.6818 13.9583 9.716 13.6733 8.861 13.17C7.86087 12.5943 6.73607 12.2697 5.583 12.224C5.26073 12.2276 4.93891 12.249 4.619 12.288C4.42324 12.3129 4.2263 12.3276 4.029 12.332C4.009 12.332 2 12.311 2 10.453C2 10.15 2.149 9.93898 2.575 9.41298C3.6114 8.26505 4.19964 6.78221 4.232 5.23598C4.25774 4.36263 4.64563 3.53935 5.30271 2.96346C5.95978 2.38757 6.82682 2.11098 7.696 2.19998C11.062 2.19998 13.8 5.95098 13.8 10.562C13.8 14 12.254 14 11.673 14Z"
        fill={fill}
      />
    </svg>
  )
}
